

import React from 'react'
import { Grid, Typography, Paper, Box } from '@mui/material'
import _ from 'lodash'
import { useNavigate } from 'react-router-dom'
import { useSelector } from "react-redux";
import KeyAreaGraph from './dynamic/KeyAreaGraph';
import DemographicsComponent from './dynamic/Demographics';
import OWSHealthAge from './dynamic/OWSHealthAge';
import BiometricsComponent from './dynamic/BiometricsComponent';
import MasonrySection from './dynamic/MasonrySection';
import SubSection from './dynamic/SubSection';
import ReadinessToChange from './dynamic/ReadinessToChange';
import AdminCompletionGraph from './dynamic/AdminCompletionGraph';
import LargeSection from './dynamic/LargeSection';
import KeyValueListFour from './dynamic/KeyValueListFour';
import OWSAdminDonut from './dynamic/OWSAdminDonut';
import DonutChart from './dynamic/DonutChart';
import KeyProgressCard from './dynamic/KeyProgressCard';
import DonutSection from './dynamic/DonutSection';
import MasonrySectionNoBG from './dynamic/MasonrySectionNoBG';
import AdminKeyAreaGraph from './dynamic/AdminKeyAreaGraph';
import TabbedComponent from './dynamic/TabbedComponent';
import AdminBiometricSection from './dynamic/AdminBiometricSection';
import HealthAgeAvgAge from './dynamic/AdminHealthAgeAvgAge';
import AdminFallRisk from './dynamic/AdminFallRisk';
import PersonalReportOverview from './dynamic/PersonalReportOverview';
import PersonalReportHealthAndWellness from './dynamic/PersonalReportHealthAndWellness';
import PersonalReportKeyAreas from './dynamic/PersonalReportKeyAreas';
import PersonalReportBiometrics from './dynamic/PersonalReportBiometrics';
import HTMLBlock from './dynamic/HTMLBlock';

import PersonalReportKeyAreaSingle from './dynamic/PersonalReportKeyAreaSingle';
import PersonalReportInfoAndOverall from './dynamic/PersonalReportInfoAndOverall';
import HomeBanner from './dynamic/HomeBanner';
import HomeAssessmentLibrary from './dynamic/HomeAssessmentLibrary';
import HomeHealthTools from './dynamic/HomeHealthTools';
import HomePreferredAssessment from './dynamic/HomePreferredAssessment';
import PersonalReportRiskList from './dynamic/PersonalReportRiskList';
import PersonalReportCallouts from './dynamic/PersonalReportCallOuts';
import PersonalReportStatementText from './dynamic/PersonalReportStatementText';
import PersonalReportAboutAssessment from './dynamic/PersonalReportAboutAssessment';
import AdminErrorMessage from './dynamic/AdminError';

const InvalidComponent = ({ component, key }) => {
    return (
        <Grid lg={2} md={2} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
            <Paper elevation={16} sx={{ padding: '40px', height: '100%' }}>
                <Box style={{ textAlign: "center" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Typography variant="h5">{component.ComponentType}</Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Grid>
    )
}

const DynamicComponentTranslation = {
    "STANDARD KEY VALUE ICON CARD": BiometricsComponent
    , "STANDARD KEY VALUE CARD": DemographicsComponent
    , "KEY AREA CHART": KeyAreaGraph
    , "OWS AND HEALTH AGE": OWSHealthAge
    , "READINESS TO CHANGE": ReadinessToChange
    , "STANDARD MASONRY SECTION": MasonrySection
    , "STANDARD KEY VALUE SUBSECTION": SubSection
    , "ADMIN COMPLETION GRAPH": AdminCompletionGraph
    , "LARGE SECTION": LargeSection
    , "KEY VALUE LIST FOUR": KeyValueListFour
    , "OWS ADMIN DONUT": OWSAdminDonut
    , "STANDARD DONUT COLOR": DonutChart
    , "KEY VALUE EXPANDED NESTED": DonutSection
    , "STANDARD KEY PROGRESS CARD": KeyProgressCard
    , "STANDARD MASONRY SECTION NO BG": MasonrySectionNoBG
    , "ADMIN KEY AREA CHART": AdminKeyAreaGraph
    , "ADMIN KEY AREA TAB": TabbedComponent
    , "ADMIN BAR DISPLAY CARD" : AdminBiometricSection
    , "HEALTH AGE AVG AGE": HealthAgeAvgAge
    , "ADMIN FALL RISK COMPONENT": AdminFallRisk
    , "PR OVERVIEW": PersonalReportOverview
    , "PR HEALTH WELLNESS": PersonalReportHealthAndWellness
    , "PR KEY AREAS": PersonalReportKeyAreas
    , "PR BIOMETRICS": PersonalReportBiometrics
    , "PR RISK LIST": PersonalReportRiskList
    , "PR CALLOUT": PersonalReportCallouts
    , "PR STATEMENT TEXT": PersonalReportStatementText
    , "PR ABOUT ASSESSMENT": PersonalReportAboutAssessment
    , "HTML BLOCK": HTMLBlock
    , "PR ASSESSMENT AND SCORE": PersonalReportInfoAndOverall    
    , "PR KEY AREA SINGLE": PersonalReportKeyAreaSingle
    , "HOME BANNER": HomeBanner
    , "ASSESSMENT LIST": HomeAssessmentLibrary
    , "HOME HEALTH LIBRARY": HomeHealthTools
    , "HOME PREFERRED ASSESSMENT": HomePreferredAssessment
    ,"ADMIN ERROR": AdminErrorMessage
}

const DynamicComponent = (props) => {
    //console.log('dynamic component', props.component)
    const navigate = useNavigate();

    if (typeof DynamicComponentTranslation[props.component.ComponentType] !== "undefined") {
        return React.createElement(DynamicComponentTranslation[props.component.ComponentType]
            , {
                key: props.index,
                component: props.component,
                otherprops:props,
                elevationdisabled: props.elevationdisabled ? true : false,
                PrintView: props.PrintView,
            }
        )
    }

    return React.createElement(
        () => <div></div>,
        { key: props.index }
    )

}


DynamicComponent.displayName = 'blockComponent';
export default React.memo(DynamicComponent)